// シェアの文面とリンク。ブラウザ (シェアボタン) と Worker (/r/{役} の SNS カード表示) の両方で使う

import type { Content, Role } from "./content";
import { DEFAULT_LOCALE } from "./i18n";

export const SITE = "https://bardclub.net";

/** 役のシェア用ページ。日本語以外は ?lang= を付けて、開いた人にも同じ言語で見せる */
export const shareUrl = (c: Content, role: Role) =>
  `${SITE}/r/${role.id}${c.locale === DEFAULT_LOCALE ? "" : `?lang=${c.locale}`}`;

export const shareTitle = (c: Content, role: Role) => c.share.title(role);
export const shareText = (c: Content, role: Role) => c.share.text(role, c.types);
export const shareDescription = (c: Content, role: Role) => c.share.description(role, c.types);
